import { render } from "./PengeluaranNotis.vue?vue&type=template&id=06dd1b39"
import script from "./PengeluaranNotis.vue?vue&type=script&lang=js"
export * from "./PengeluaranNotis.vue?vue&type=script&lang=js"

import "./PengeluaranNotis.vue?vue&type=style&index=0&id=06dd1b39&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__